import React, { useEffect } from 'react'
import useTrans from '../../../../../hooks/useTrans'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import { getRequiredFields, getVisibleFields } from '../../../../../utils/servicegift'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import FormCheckbox from '../../../../atoms/FormCheckbox/FormCheckbox'
import Autorizzazioni from '../Autorizzazioni/Autorizazzioni'

const Credenziali = ({
  props,
  setStep,
  step,
  social,
  getUrlCondizioniGenerali,
  variant = 'registrazione',
  withAutorizzazioni = false,
}) => {
  const t = useTrans()
  const router = useRouter()
  const isCheckout = variant === 'checkout'
  const { service_gift } = useSelector((state) => state?.servicegift)
  const visibleFields = getVisibleFields(service_gift, props.values.utente.tipologia, variant)
  const requiredFields = getRequiredFields(service_gift, props.values.utente.tipologia, variant)

  const { email, nome, cognome } = router.query

  useEffect(() => {
    if (social) {
      props.setFieldValue('utente.email', email)
      props.setFieldValue('utente.username', email)
      props.setFieldValue('utente.nome', nome)
      props.setFieldValue('utente.cognome', cognome)
    }
  }, [email, nome, cognome])

  return (
    <div className="step-registrazione">
      <div className="step-registrazione__fieldsets">
        <FormField
          label={t('Nome') + ' *'}
          status={
            props.touched.utente?.nome && props.errors.utente?.nome
              ? 'error'
              : props.touched.utente?.nome && 'success'
          }
          errorMessage={props.errors?.utente?.nome}
        >
          <FormInput
            placeholder={t('Inserisci il nome')}
            value={props.values.utente.nome}
            onBlur={props.handleBlur('utente.nome')}
            onChange={props.handleChange('utente.nome')}
          ></FormInput>
        </FormField>

        <FormField
          label={t('Cognome') + ' *'}
          status={
            props.touched.utente?.cognome && props.errors.utente?.cognome
              ? 'error'
              : props.touched.utente?.cognome && 'success'
          }
          errorMessage={props.errors?.utente?.cognome}
        >
          <FormInput
            placeholder={t('Inserisci il cognome')}
            value={props.values.utente.cognome}
            onBlur={props.handleBlur('utente.cognome')}
            onChange={props.handleChange('utente.cognome')}
          ></FormInput>
        </FormField>

        {visibleFields.includes('utente.telefono') && (
          <FormField
            label={t('telefono') + (requiredFields.includes('utente.telefono') ? ' *' : '')}
            status={
              props.touched.utente?.telefono && props.errors.utente?.telefono
                ? 'error'
                : props.touched.utente?.telefono && 'success'
            }
            errorMessage={props.errors?.utente?.telefono}
            infoMessage={t('Inserisci il numero di telefono con il prefisso nazionale')}
          >
            <FormInput
              value={props.values.utente.telefono}
              placeholder={t('Inserisci il numero di cellulare')}
              onBlur={props.handleBlur('utente.telefono')}
              onChange={props.handleChange('utente.telefono')}
            ></FormInput>
          </FormField>
        )}

        {!social && (
          <FormField
            label={(isCheckout ? t('E-mail') : t('Username')) + ' *'}
            status={
              props.touched.utente?.username && props.errors.utente?.username
                ? 'error'
                : props.touched.utente?.username && 'success'
            }
            errorMessage={props.errors?.utente?.username}
            className="step-registrazione__fieldset--full-row"
            infoMessage={t(
              'questa email potrà essere utilizzata per comunicazioni inerenti alla gestione degli ordini'
            )}
          >
            <FormInput
              placeholder={t('Inserisci il tuo indirizzo email')}
              value={props.values.utente?.username}
              onBlur={props.handleBlur('utente.username')}
              onChange={props.handleChange('utente.username')}
            />
          </FormField>
        )}

        {isCheckout && (
          <FormField className="step-registrazione__fieldset--full-row">
            <FormCheckbox
              label={t('Voglio creare un account sul sito')}
              onChange={() =>
                props.setFieldValue('with_registrazione', !props.values.with_registrazione)
              }
              checked={props.values.with_registrazione}
              onBlur={props.handleBlur('with_registrazione')}
            />
          </FormField>
        )}

        {!social && (!isCheckout || (isCheckout && props.values.with_registrazione)) && (
          <FormField
            label={t('password') + ' *'}
            status={
              props.touched.utente?.password && props.errors.utente?.password
                ? 'error'
                : props.touched.utente?.password && 'success'
            }
            errorMessage={props.errors?.utente?.password}
          >
            <FormInput
              type="password"
              placeholder={t('Inserisci la password')}
              value={props.values.utente?.password}
              onBlur={props.handleBlur('utente.password')}
              onChange={props.handleChange('utente.password')}
            ></FormInput>
          </FormField>
        )}
        {!social && (!isCheckout || (isCheckout && props.values.with_registrazione)) && (
          <FormField
            label={t('conferma password') + ' *'}
            status={
              props.touched.utente?.conferma_password && props.errors.utente?.conferma_password
                ? 'error'
                : props.touched.utente?.conferma_password && 'success'
            }
            errorMessage={props.errors?.utente?.conferma_password}
          >
            <FormInput
              type="password"
              placeholder={t('Ripeti la password')}
              value={props.values.utente?.conferma_password}
              onBlur={props.handleBlur('utente.conferma_password')}
              onChange={props.handleChange('utente.conferma_password')}
            ></FormInput>
          </FormField>
        )}
      </div>

      {isCheckout && withAutorizzazioni && (
        <div className="step-registrazione__inner-content">
          <Autorizzazioni
            step={step}
            setStep={setStep}
            props={props}
            getUrlCondizioniGenerali={getUrlCondizioniGenerali}
            variant={variant}
          />
        </div>
      )}

      <p className="step-registrazione__legend">*{t('Campi obbligatori')}</p>

      <Button
        disabled={
          props.errors.utente ||
          (props.values.initialData ? false : !props.dirty) ||
          (withAutorizzazioni ? props.errors.autorizzazioni : false)
        }
        label={t('Conferma dati')}
        variant="primary"
        size="medium"
        onClick={() => setStep(step + 1)}
      />
    </div>
  )
}

export default Credenziali
